import { useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import "./App.css";
import { Canvas } from "./components/canvas/Canvas";
import { Provider } from "react-redux";
import theme from "./styles/theme";
import { store } from "./store";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./components/landing/LandingPage";
import { ProblemLibraryPage } from "./components/problems/ProblemLibraryPage";
import { AuthProvider } from "./components/auth/AuthProvider";
import { AuthCallbackPage } from "./components/auth/AuthCallbackPage";
import { initAuth } from "./store/auth/authSlice";
// The deploy workflows copy index.html to each of these paths so a direct load is not an S3 404
import ROUTES from "./config/routes.json";

export const AUTH_CALLBACK_PATH = ROUTES.authCallback;

function App() {
  const authStartedRef = useRef(false);
  useEffect(() => {
    // Once per load (StrictMode runs effects twice); the Google callback page settles the state itself
    if (authStartedRef.current) return;
    authStartedRef.current = true;
    if (window.location.pathname !== AUTH_CALLBACK_PATH) {
      void store.dispatch(initAuth());
    }
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path={ROUTES.app} element={<Canvas />} />
              <Route path={ROUTES.problems} element={<ProblemLibraryPage />} />
              <Route path={AUTH_CALLBACK_PATH} element={<AuthCallbackPage />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
